import { render, staticRenderFns } from "./CopySurvey.vue?vue&type=template&id=c924a62c"
import script from "./CopySurvey.vue?vue&type=script&lang=js"
export * from "./CopySurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports